<template>
  <aha-modal
    :title="'Presentation being edited on AhaSlides'"
    @hide="$emit('cancel')"
    :closable="false"
    :noCloseOnBackdrop="true"
    :noCloseOnEsc="true"
  >
    <p>Reload to continue presenting.</p>
    <template #action>
      <aha-button
        variant="primary"
        @click="onClickReload"
        :submitting="isReloading"
        :disabled="isReloading"
      >
        Reload
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
export default {
  name: 'MSTeamsReloadModal',
  props: {
    isReloading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickReload() {
      this.$emit('ok')
    },
  },
}
</script>
